export default "__VITE_ASSET__En6KBJQ2__"